import * as React from 'react';


import('./FocusMatchStyles.scss');


interface FocusMatchPresentationProps {
    focusMatchStatus: string
    focusmatchid: number
    children?: React.ReactNode
    layout: string
}

class FocusMatchPresentation extends React.Component<FocusMatchPresentationProps> {
    render() {
        return (
            <div className={"focusmatch " + this.props.layout} >
                {this.props.focusMatchStatus == 'active'
                    ? this.renderMatch()
                    : this.props.focusMatchStatus == 'checking'
                        ? this.renderChecking()
                        : this.props.focusMatchStatus == 'ended'
                            ? this.renderEnded()
                            : this.props.focusMatchStatus == 'upcoming'
                                ? this.renderUpcoming()
                                : this.renderError()
                }
            </div>
        );
    }

    renderMatch() {
        return (
            <div className="match">
                {this.props.children}
            </div>
        );
    }

    renderChecking() {
        //
        return('');
    }

    renderEnded() {
        console.warn('Match '+this.props.focusmatchid+' has already ended');
        return('');
    }

    renderUpcoming() {
        console.warn('Match '+this.props.focusmatchid+' didnt start yet');
        return('');
    }

    renderError() {
        console.warn('Match '+this.props.focusmatchid+' not found');
        return('');
    }

};

export default FocusMatchPresentation;
